import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            lerp: 0.08,
            smoothWheel: true,
            wheelMultiplier: 1.0,
            touchMultiplier: 1.4
        });

        let raf;
        function loop(time) {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        }
        raf = requestAnimationFrame(loop);

        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return <>{children}</>;
}
